import { render, staticRenderFns } from "./filterItem.vue?vue&type=template&id=06e08870&scoped=true"
import script from "./filterItem.vue?vue&type=script&lang=js"
export * from "./filterItem.vue?vue&type=script&lang=js"
import style0 from "./filterItem.vue?vue&type=style&index=0&id=06e08870&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e08870",
  null
  
)

export default component.exports